export const delayedEventListener = (eventListener: () => void): void => {
  setTimeout(eventListener);
};
